import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import PersonIcon from '@mui/icons-material/Person';
import ReportIcon from '@mui/icons-material/Report';
import GridViewIcon from '@mui/icons-material/GridView';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LogoutIcon from '@mui/icons-material/Logout';

import { useNavigate } from "react-router-dom";
const cards = [
  {
    id: 1,
    title: 'Profile',
    description: 'Vew Account Details.',
    icon: <PersonIcon/>,
    url: '/account'
  },
  {
    id: 2,
    title: 'My Lots',
    description: 'View Your Lots.',
    icon: <GridViewIcon/>,
    url: '/mylots'
    
  },
  // {
  //   id: 3,
  //   title: 'Invoice',
  //   description: 'View Your Invoice',
  //   icon: <ReportIcon/>,
  //   url: '/invoice'
  // },
  // {
  //   id: 4,
  //   title: 'My Favorite',
  //   description: 'View your Favoirte',
  //   icon: <FavoriteIcon/>,
  //   url: '/myfavorite'
  // },
  {
    id: 5,
    title: 'Logout',
    description: 'Exit Account',
    icon: <LogoutIcon/>,
    url: '/logout'
  },
];


function SelectActionCard() {
  const navigate = useNavigate();

    const handlePage = (e,value) => {

      switch (value) {
        case "/account":
          navigate("/account");
          break;
  
          case "/mylots":
              navigate("/mylots");
          break;

          // case "/invoice":
          //     navigate("/invoice");
          // break;

          case "/myfavorite":
              navigate("/myfavorite");
          break;
          case "/logout":
            localStorage.removeItem("@storage_Key");
            localStorage.removeItem("token");
            window.location.href = "/login";
        break;
  
        default:
        // code block
      }
 
    }
  // const [selectedCard, setSelectedCard] = React.useState(0);
  return (
    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))',
        gap: 3,
      }}
    >
      {cards.map((card, index) => {

        return  (
        <Card>
          <CardActionArea
            onClick={(e) => handlePage(e,card.url)}
            data-active={""}
            sx={{
              height: '100%',
              '&[data-active]': {
                backgroundColor: 'action.selected',
                '&:hover': {
                  backgroundColor: 'action.selectedHover',
                },
              },
            }}
          >
            <CardContent sx={{ height: '100%' }}>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <Typography variant="h5" component="div">
                {card.title}
              </Typography>
            {card.icon}
            </div>

  
             
              <Typography variant="body2" color="text.secondary">
                {card.description}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      )
      })
      }
    </Box>
  );
}

export default SelectActionCard;
